// extracted by mini-css-extract-plugin
export default {"thankYouSection":"Thankyou_thankYouSection__x88Ws","thankYouContentSection":"Thankyou_thankYouContentSection__yOP-A","homeButton":"Thankyou_homeButton__99etP"};